import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import UploadPage from './pages/Upload';
import RecipientPage from './pages/Recipient';
import ReceivedPackagePage from './pages/ReceivedPackage';
import SpacesPage from './pages/Spaces';
import DashboardPage from './pages/Dashboard';
import HowItWorksPage from './pages/HowItWorks';
import SecurityPage from './pages/Security';
import FAQPage from './pages/FAQ';
import { UpgradeSuccess, UpgradeCancel } from './pages/Upgrade';
import GuidePage from './pages/Guide';
import { GUIDES } from './content/guides';
import { initGA, logPageView } from './utils/analytics';
import { captureReferralCode } from './api';

// Tiny inner component: accesses useLocation (must be inside <BrowserRouter>)
// to fire a GA page_view on every SPA route change.
function RouteAnalytics() {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

export default function App() {
  // Initialize GA once on mount. No-op if VITE_GA_ID isn't configured.
  useEffect(() => { initGA(); }, []);

  // A colleague's shared link lands as /?ref=st… . Stash it before anything
  // navigates away — verification happens after an email round-trip.
  useEffect(() => { captureReferralCode(); }, []);

  return (
    <>
      <RouteAnalytics />
      <Header />
      <ErrorBoundary>
      <Routes>
        <Route path="/"             element={<UploadPage />} />
        <Route path="/r/:token"     element={<RecipientPage />} />
        {/* A received package, opened by its addressee from the dashboard.
            The download token rides the fragment (#dt=), never the query. */}
        <Route path="/received/:recipientId" element={<ReceivedPackagePage />} />
        <Route path="/dashboard"    element={<DashboardPage />} />
        <Route path="/spaces"       element={<SpacesPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/security"     element={<SecurityPage />} />
        <Route path="/faq"          element={<FAQPage />} />
        {/* Stripe's success_url/cancel_url have always pointed here; until now
            neither route existed and a payer hit the SPA catch-all. */}
        {/* Task pages — the queries an office types with a file in hand.
            Enumerated rather than a wildcard so an unknown path still falls to
            the catch-all upload page instead of a "not found". */}
        {GUIDES.map((g) => (
          <Route key={g.slug} path={`/${g.slug}`} element={<GuidePage slug={g.slug} />} />
        ))}
        <Route path="/upgrade/success" element={<UpgradeSuccess />} />
        <Route path="/upgrade/cancel"  element={<UpgradeCancel />} />
        <Route path="*"             element={<UploadPage />} />
      </Routes>
      </ErrorBoundary>
      <Footer />
    </>
  );
}
